import { StaticImage } from "gatsby-plugin-image"
import React, { useEffect, useState } from "react"
import RTOPopularState from "./RTOPopularState"
import RTOServiceOffered from "./RTOServiceOffered"

const RTOOfficesCityContent = ({ filterCityData }) => {
  return (
    <div className="container rto-pages">
      <div className="clearfix">
        <div className="col-md-12">
          <h1 className="fs-3 fw7 mt-5 mb-4 pb-3">
            {`RTO Office ${filterCityData && filterCityData.city} ${
              filterCityData && filterCityData.code
            } Phone Number and Address`}
          </h1>
        </div>
        <div className="col-md-12 mt25 mb25 mobile-add d-block d-md-none">
          <p className="f20 fw8 text-center mb15">
            Get 30% Off on GPS Vehicle Tracking System
          </p>
          <a
            href="https://www.amazon.in/stores/page/C91DBA02-61DC-4EE4-9C38-78D8EE235237?channel=Vahan%20Pages"
            target="_blank"
            rel="noreferrer"
          >
            <StaticImage
              src="../images/rto-images/amazon-banner-mobile.webp"
              alt=""
            />
          </a>
        </div>
        <div className="fs-6 d-none d-md-block">
          <a
            className="banner-click"
            href="https://www.amazon.in/stores/page/C91DBA02-61DC-4EE4-9C38-78D8EE235237?channel=Vahan%20Pages"
            target="_blank"
            rel="noreferrer"
          >
            <StaticImage
              src="../images/rto-images/amazon-banner-desktop.webp"
              alt=""
            />
          </a>
          {filterCityData ? (
            filterCityData.content ? (
              <p className="mt-3 mb-5">
                {filterCityData && filterCityData.content}
              </p>
            ) : (
              <p className="mt-3 mb-5">
                Regional Transport Office (RTO) or Regional Transport Authority
                (RTA) is a government body that is responsible for carrying out
                all the duties and functions that are detailed in the Motor
                Vehicles Act, 1988. Every state and city in India has its own
                Regional Transport Office that falls under the Motor Vehicles
                Department. The department, headed by the Transport
                Commissioner, has been formulated under section 213(1) of the
                Motor Vehicles Act, 1988, which states that "The State
                Government may, for the purpose of carrying into effect the
                provisions of the Act, establish a Motor Vehicles Department and
                appoint as officers thereof such persons as it thinks fit." The
                primary role of an RTO is to maintain a comprehensive database
                of all motor vehicles registered in that particular city, state
                or union territory, and to monitor and enforce the various rules
                and regulations mentioned in the Motor Vehicles Act, 1988.
              </p>
            )
          ) : (
            ""
          )}
        </div>

        <div className="col-md-12 mt80 mb80">
          <h2 className="text-center mb40 mt0">
            RTO Office {filterCityData && filterCityData.city}{" "}
            {filterCityData && filterCityData.code} Phone Number and Address
          </h2>
          <div class="rto-office-card">
            <h4 class="text-center">
              {filterCityData && filterCityData.city}{" "}
              {filterCityData && filterCityData.code} RTO Office
            </h4>
            <div class="card-details">
              <div class="card-details-row">
                <p>RTO Code</p>
                <p>{filterCityData && filterCityData.code}</p>
              </div>
              <div class="card-details-row">
                <p>Address</p>
                <p>{filterCityData && filterCityData.address}</p>
              </div>
              <div class="card-details-row">
                <p>Phone Number</p>
                <p>{filterCityData && filterCityData.phone}</p>
              </div>
              <div class="card-details-row">
                <p>Office Timings</p>
                <p>
                  {filterCityData && filterCityData.timings
                    ? filterCityData.timings
                    : "09:30 AM - 06:30 PM"}
                </p>
              </div>
            </div>
          </div>
        </div>

        <RTOServiceOffered />

        <div className="col-md-12 py-80">
          <h2 className="text-center mb40 mt0">Popular RTO Offices</h2>
          <RTOPopularState />
        </div>
      </div>
    </div>
  )
}

export default RTOOfficesCityContent
